export const state = () => ({
  error: {
    register: '',
    resetpw: '',
    auth: '',
    fileInput: ''
  },
});

export const actions = {
  set({commit}, error) {
    commit('SET', error);
    setTimeout(() => {
      commit('CLEAR', error.block)
    }, 3000)
  },
  clear({commit}, block) {
    commit('CLEAR', block);
  },
};

export const mutations = {
  SET(state, error) {
    state.error[error.block] = error.message;
  },
  CLEAR(state, block) {
    state.error[block] = ""
  },
};

export const getters = {
  getError: (state) => {
    return state.error;
  },
};